import { z } from 'zod';
import {} from '../time/dateRange.js';
import { calendarDateSchema, dateRangeListSchema, nameSchema } from './common.js';
import { compareDates } from '../time/calendarDate.js';
export const createSojournInputSchema = z
    .strictObject({
    name: nameSchema,
    startDate: calendarDateSchema,
    endDate: calendarDateSchema,
})
    .refine((value) => compareDates(value.startDate, value.endDate) < 0, {
    error: 'The sojourn must end after it starts',
    path: ['endDate'],
});
export const updateSojournInputSchema = z
    .strictObject({
    name: nameSchema.optional(),
    startDate: calendarDateSchema.optional(),
    endDate: calendarDateSchema.optional(),
})
    .refine((value) => Object.keys(value).length > 0, {
    error: 'Provide at least one field to update',
})
    .refine((value) => value.startDate === undefined ||
    value.endDate === undefined ||
    compareDates(value.startDate, value.endDate) < 0, { error: 'The sojourn must end after it starts', path: ['endDate'] });
/**
 * Nights the house is actually usable; several ranges model a house that is
 * free, then taken, then free again. Omitted means "the whole sojourn".
 */
export const setSojournHouseInputSchema = z.strictObject({
    availability: dateRangeListSchema.optional(),
});
/**
 * Nights the guest sleeps on site; several ranges model a guest who leaves and
 * comes back. Omitted means "the whole sojourn".
 */
export const setSojournGuestInputSchema = z.strictObject({
    stays: dateRangeListSchema.optional(),
});
/** An empty note clears whatever was recorded for that day. */
export const setSojournDayNoteInputSchema = z.strictObject({
    note: z.string().trim().max(500),
});
//# sourceMappingURL=sojourns.js.map